import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "components/ui";
import styles from "./dialog.module.scss";
import CheckIcon from "Assets/icon/icon-check-big.svg";
import { CommonModalProps } from "./common";

interface StatusProps extends CommonModalProps {}
const StatusDialog = ({
  title,
  description,
  action,
  isOpen,
  onCloseAction,
}: StatusProps) => {
  const toggle = () => {
    onCloseAction();
  };

  return (
    <Modal
      isOpen={isOpen}
      style={{ width: "100%", maxWidth: "440px" }}
      className={styles["modal"]}
      contentClassName={styles["modal-content"]}
      centered
      data-testid="modal"
    >
      <ModalBody
        className={`${styles["body"]} ${styles["status"]}`}
        data-testid="modal-body"
      >
        <p className={`${styles["title"]}`}>{title}</p>
        <p className={`text-small ${styles["description"]}`}>{description}</p>
        <img src={CheckIcon} alt="icon" />
      </ModalBody>
      <ModalFooter className={styles["footer"]}>
        <Button variant="primary" onClick={toggle} className="sans">
          {action}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StatusDialog;
